"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ENCOUNTER_LAB_RESULTS_MAX () {
        return ENCOUNTER_LAB_RESULTS_MAX;
    },
    get ENCOUNTER_LAB_SUGGESTED_MAX () {
        return ENCOUNTER_LAB_SUGGESTED_MAX;
    },
    get EncounterAttachedLabResultSchema () {
        return EncounterAttachedLabResultSchema;
    },
    get EncounterLabAttachRequestSchema () {
        return EncounterLabAttachRequestSchema;
    },
    get EncounterLabAttachResponseSchema () {
        return EncounterLabAttachResponseSchema;
    },
    get EncounterLabDetachResponseSchema () {
        return EncounterLabDetachResponseSchema;
    },
    get EncounterLabResultsResponseSchema () {
        return EncounterLabResultsResponseSchema;
    },
    get EncounterLabSourceStateSchema () {
        return EncounterLabSourceStateSchema;
    },
    get encounterLabResultIds () {
        return encounterLabResultIds;
    }
});
const _zod = require("zod");
const _encounterdetail = require("./encounter-detail");
const _labresult = require("../lab-results/lab-result");
const ENCOUNTER_LAB_RESULTS_MAX = 50;
const ENCOUNTER_LAB_SUGGESTED_MAX = 20;
const isoDateTime = ()=>_zod.z.string().datetime({
        offset: true
    });
const encounterLabResultIds = ()=>_zod.z.array(_zod.z.string().uuid({
        message: 'Each lab result id must be a UUID.'
    })).max(ENCOUNTER_LAB_RESULTS_MAX, {
        message: `At most ${ENCOUNTER_LAB_RESULTS_MAX} lab results per encounter.`
    }).refine((ids)=>new Set(ids.map((id)=>id.toLowerCase())).size === ids.length, {
        message: 'Lab result ids must be unique.'
    });
const EncounterLabSourceStateSchema = _zod.z.enum([
    'current',
    'changed',
    'removed'
]);
const { id: labResultId, ...labResultContent } = _labresult.LabResultSchema.shape;
const EncounterAttachedLabResultSchema = _zod.z.object({
    labResultId,
    ...labResultContent,
    attachedAt: isoDateTime(),
    attachedBy: _encounterdetail.EncounterUserRefSchema,
    sourceState: EncounterLabSourceStateSchema
}).strict().superRefine((result, ctx)=>{
    const isReviewed = result.status === 'reviewed';
    const hasReviewedAt = result.reviewedAt !== null;
    if (isReviewed !== hasReviewedAt) {
        ctx.addIssue({
            code: 'custom',
            path: [
                'reviewedAt'
            ],
            message: 'reviewedAt must be set if and only if status is reviewed.'
        });
    }
});
const EncounterLabResultsResponseSchema = _zod.z.object({
    encounterId: _zod.z.string().uuid(),
    gatewayEnabled: _zod.z.boolean(),
    attached: _zod.z.array(EncounterAttachedLabResultSchema).max(ENCOUNTER_LAB_RESULTS_MAX),
    suggested: _zod.z.array(_labresult.LabResultSchema).max(ENCOUNTER_LAB_SUGGESTED_MAX),
    attachedCount: _zod.z.number().int().min(0),
    suggestedTotal: _zod.z.number().int().min(0)
}).strict();
const EncounterLabAttachRequestSchema = _zod.z.object({
    labResultIds: encounterLabResultIds().min(1, {
        message: 'Pick at least one lab result to attach.'
    })
}).strict();
const EncounterLabAttachResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    labResultIds: _zod.z.array(_zod.z.string().uuid()),
    attachedCount: _zod.z.number().int().min(0)
}).strict();
const EncounterLabDetachResponseSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    labResultId: _zod.z.string().uuid(),
    attachedCount: _zod.z.number().int().min(0)
}).strict();
